import {useDispatch} from 'react-redux';
import {setPaymentAmount, handleCurrentStep, setShowPopup} from '../DebtAndUpdatePaymentBlockSlice';

export const useDebtPaymentSelectAmount = () => {
  const dispatch = useDispatch();

  const actions = {
    setAmount: (amount) => dispatch(setPaymentAmount(amount)),
    handleCurrentStep: (step) => dispatch(handleCurrentStep(step)),
    setShowPopup: (popup) => dispatch(setShowPopup(popup)),
  };

  return {actions};
};
